// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1JswL","content":"RecentSearches_content__1Tcm4"};